@if (score && score.currentlyServing) {
    <div class="column sets basepad">
        <div class="cell" [class.hidden-visibility]="score.currentlyServing !== 1">
            @if (!isBaseVisible) {
                <div class="{{ homeTeamBase }}"></div>
            } @else {
                <span class="baseball-indicator"><vn-icon size="12" [name]="homeTeamBase ?? ''" /></span>
            }
        </div>
        <div class="cell" [class.hidden-visibility]="score.currentlyServing !== 2">
            @if (!isBaseVisible) {
                <div class="{{ awayTeamBase }}"></div>
            } @else {
                <span class="baseball-indicator"><vn-icon size="12" [name]="awayTeamBase ?? ''" /></span>
            }
        </div>
    </div>
}
@if (games) {
    <div class="column sets">
        <div class="cell">
            <div [msValueSlider]="games.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="games.participant2.toString()"></div>
        </div>
    </div>
}
